import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function RefRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [valid, setValid] = useState(null);

  useEffect(() => {
    api.get(`/public/partner/${code}`).then((r) => {
      if (r.data.valid) localStorage.setItem("nova_ref", r.data.code);
      setValid(r.data.valid);
      setTimeout(() => navigate("/contact", { replace: true }), 1200);
    }).catch(() => { setValid(false); setTimeout(() => navigate("/", { replace: true }), 1200); });
  }, [code, navigate]);

  return (
    <div className="min-h-screen nova-aurora flex items-center justify-center text-center px-4">
      <div>
        <Loader2 className="w-8 h-8 text-violet-400 animate-spin mx-auto mb-4" />
        <p className="text-slate-300">{valid === false ? "Invalid referral link — redirecting…" : "Applying your referral — redirecting…"}</p>
      </div>
    </div>
  );
}
